import PropTypes from 'prop-types'
import React, { useState, useEffect } from "react"
import {
  Row,
  Col,
  Card,
  Alert,
  CardBody,
  Button,
  CardTitle,
  CardSubtitle
} from "reactstrap"

// availity-reactstrap-validation

// Redux
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"

//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb";
import Utils from '../Utility'
import { post, get } from "../../helpers/api_helper";

import avatar from "../../assets/images/companies/img-4.png"
// actions
import { createCompany, companySuccess, companyError, updateCompany } from "../../store/actions";
import { profileSuccess, getProfile } from '../../store/auth/profile/actions';
import AddLeadForm from '../Forms/AddLeadForm';
import Loader from "../../components/Loader";
import UnassignedLeads from './Unassigned';
import AssignedLeads from './assigned';
import ArchivedLeads from './Archived';
import ByProjectLeads from './ByProject';
import Lead from './Lead';
import LeadSingle from '../Lead/LeadSingle';

const Leads = props => {
  const { user, company } = props;
  const [isAddForm, setIsAddForm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [currentTab, setCurrentTab] = useState("unassigned");
  const [leadId, setLeadId] = useState(null);
  const [currentLead, setCurrentLead] = useState(null);
  const [projectId, setProjectId] = useState(null);
  const [countData, setCountData] = useState({ unassigned: 0, assigned: 0, archived: 0 });
  const [reload, setReload] = useState(false);
  // console.log('props on Leads', props);

  useEffect(() => {
    if (props.location.pathname == '/auto/lead') {
      if (user?.role != 'Dealer')
        props.history.replace("/auto/lead/unassigned");
      else
        setCurrentTab("lead");
    } else {
      if (props?.location?.pathname) {
        let path = props.location.pathname;
        console.log('path name 1', path);
        console.log('path name 2', path.split("/"));
        if (path.split("/").length > 3)
          setProjectId(path.split("/")[4]);
        path = path.split("/")[3];
        console.log('path name 3', path);
        if (path != "unassigned" && path != "assigned" && path != "archived" && path != "project") {
          setLeadId(path);
          setCurrentTab("single");
        } else
          setCurrentTab(path);
      }
    }
  }, [props.location]);

  useEffect(() => {
    if (user) {
      getLeadsCount();
    }
  }, [user, reload]);

  const getLeadsCount = () => {
    get('/lead/count?companyId=' + user?.companyId + "&kind=auto", { token: user?.token })
      .then(json => {
        console.log('response from lead count', json);
        if (json?.statusCode == 200)
          setCountData(json?.data)
      })
      .catch(error => {
        console.error('error while getting lead count', error);
      })
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Loader visible={loading} />
        {/* Render Breadcrumb */}
        <Breadcrumb title={Utils.projectName} breadcrumbItem="Lead" />
        <Row>
          <Col lg="12">
            {props.error && props.error ? (
              <Alert color="danger">{props.error}</Alert>
            ) : null}
            {props.success && props.success ? (
              <Alert color="success">{props.success}</Alert>
            ) : null}
          </Col>
        </Row>
        {isAddForm ?
          <AddLeadForm
            role={"Lead"}
            user={user}
            data={currentLead}
            close={setIsAddForm}
            loading={loading}
            setLoading={setLoading}
            setCurrentUser={setCurrentLead}
          />
          : <Card>
            <CardBody>
              <div className="d-flex" style={{ marginLeft: 'auto', marginBottom: 10 }}>
                <div>
                  <CardTitle className="h4">{props.role}</CardTitle>
                  {currentTab != "single" &&
                    <CardSubtitle className="mb-3">
                      All the <code>Leads</code> can be manage from here!.
                    </CardSubtitle>
                  }
                </div>
                <div className="text-center" style={{ marginLeft: 'auto' }}>
                  {currentTab != "single" ?
                    <Button style={{ backgroundColor: props?.user?.company?.theme ? props.user?.company?.theme : Utils.themeColor }} onClick={() => setIsAddForm(true)}>
                      Add
                    </Button>
                    :
                    <Button style={{ backgroundColor: props?.user?.company?.theme ? props.user?.company?.theme : Utils.themeColor }} onClick={() => props?.history?.goBack()}>
                      Back
                    </Button>
                  }
                </div>
              </div>
              {currentTab !== 'single' &&
                <Row>
                  <Col lg="12">
                    <div className="d-flex" style={{ marginBottom: 30 }}>
                      {user?.role != 'Dealer' &&
                        <>
                          {currentTab == 'unassigned' ?
                            <Button style={{ backgroundColor: props?.user?.company?.theme ? props.user?.company?.theme : Utils.themeColor, marginLeft: 15, marginRight: 5 }}>Unassigned ({countData?.unassigned})</Button>
                            :
                            <Button style={{ backgroundColor: 'transparent', marginLeft: 15, marginRight: 5 }}
                              onClick={() => props.history.replace("/auto/lead/unassigned")}
                            ><span style={{ color: props?.user?.company?.theme ? props.user?.company?.theme : Utils.themeColor }}>Unassigned ({countData?.unassigned})</span></Button>
                          }
                          {currentTab == 'assigned' ?
                            <Button style={{ backgroundColor: props?.user?.company?.theme ? props.user?.company?.theme : Utils.themeColor, marginLeft: 5, marginRight: 5 }}>Assigned ({countData?.assigned})</Button>
                            :
                            <Button style={{ backgroundColor: 'transparent', marginLeft: 5, marginRight: 5 }}
                              onClick={() => props.history.replace("/auto/lead/assigned")}
                            ><span style={{ color: props?.user?.company?.theme ? props.user?.company?.theme : Utils.themeColor }}>Assigned ({countData?.assigned})</span></Button>
                          }
                          {user?.role == 'Admin' &&
                            <>
                              {currentTab == 'archived' ?
                                <Button style={{ backgroundColor: props?.user?.company?.theme ? props.user?.company?.theme : Utils.themeColor, marginLeft: 5, marginRight: 5 }}>Archived ({countData?.archived})</Button>
                                :
                                <Button style={{ backgroundColor: 'transparent', marginLeft: 5, marginRight: 5 }}
                                  onClick={() => props.history.replace("/auto/lead/archived")}
                                ><span style={{ color: props?.user?.company?.theme ? props.user?.company?.theme : Utils.themeColor }}>Archived ({countData?.archived})</span></Button>
                              }
                            </>
                          }
                          {currentTab == 'project' ?
                            <Button style={{ backgroundColor: props?.user?.company?.theme ? props.user?.company?.theme : Utils.themeColor, marginLeft: 5, marginRight: 5 }}>By Project</Button>
                            :
                            <Button style={{ backgroundColor: 'transparent', marginLeft: 5, marginRight: 5 }}
                              onClick={() => props.history.replace("/auto/lead/project")}
                            ><span style={{ color: props?.user?.company?.theme ? props.user?.company?.theme : Utils.themeColor }}>By Project</span></Button>
                          }
                        </>
                      }
                    </div>
                  </Col>
                </Row>
              }
              {currentTab == 'unassigned' &&
                <UnassignedLeads
                  user={user}
                  setIsAddForm={setIsAddForm}
                  setCurrentLead={setCurrentLead}
                  history={props.history}
                  reload={reload}
                  setReload={setReload}
                />
              }
              {currentTab == 'assigned' &&
                <AssignedLeads
                  user={user}
                  setIsAddForm={setIsAddForm}
                  setCurrentLead={setCurrentLead}
                  history={props.history}
                  reload={reload}
                  setReload={setReload}
                />
              }
              {currentTab == 'archived' &&
                <ArchivedLeads
                  user={user}
                  setIsAddForm={setIsAddForm}
                  setCurrentLead={setCurrentLead}
                  history={props.history}
                  reload={reload}
                  setReload={setReload}
                />
              }
              {currentTab == 'project' &&
                <ByProjectLeads
                  user={user}
                  setIsAddForm={setIsAddForm}
                  setCurrentLead={setCurrentLead}
                  projectId={projectId}
                  history={props.history}
                />
              }
              {currentTab == "lead" &&
                <Lead
                  user={user}
                  setIsAddForm={setIsAddForm}
                  setCurrentLead={setCurrentLead}
                  history={props?.history}
                />
              }
              {currentTab == "single" &&
                <LeadSingle
                  user={user}
                  leadId={leadId}
                />
              }
            </CardBody>
          </Card>
        }

      </div>
    </React.Fragment>
  )
}

Leads.propTypes = {
  getProfile: PropTypes.func,
  error: PropTypes.any,
  success: PropTypes.any,
  companyError: PropTypes.func,
  companySuccess: PropTypes.func,
  createCompany: PropTypes.func,
  updateCompany: PropTypes.func
}

const mapStatetoProps = state => {
  const { user } = state.Profile;
  const { company } = state.Company;
  return { user, company }
}

export default withRouter(
  connect(mapStatetoProps, { createCompany, companySuccess, companyError, getProfile, updateCompany })(Leads)
)
